// extracted by mini-css-extract-plugin
module.exports = {"section":"InexactDaysButtons_section__m44Lx"};